import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Show } from '../../../components';
import {
  CardForm,
  ContanierSection,
  FormHeader,
  Loading,
  Toast,
} from '../../../uiComponents/common';
import styles from './loyalty.module.css';
import { useMutation, useQuery } from 'react-query';
import { WelletContext } from '../../../context/wellet/welletContext';
import { useSelector } from 'react-redux';
import { changesCategory, getSalesCategorysNew, getUserSalesCategorys } from '../../../services';
import { defaultQueryOptions } from '../../../utils/defaultQueryOptions';
import { Card, CardContent } from '@/components/ui/card';
import { hasAllowedRoles } from '@/helpers/roles';
import { useUser } from '@/hooks';
import LoyaltyCommissionCard from './loyaltyCommssionCard';
import { Button } from '@/components/ui/button';

const Loyalty = ({ id, affiliateType, userQuery }) => {
  const { t, i18n } = useTranslation('translation', {
    keyPrefix: 'screens.profile.loyalty',
  });
  const { t: tGeneric } = useTranslation('translation', {
    keyPrefix: 'generic',
  });
  const welletContext = useContext(WelletContext);
  const organization = useSelector((state) => state.app.selectedOrganization);
  const { roles } = useUser();
  // Estado para la categoría seleccionada
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  // Fetch all available categories
  const {
    data: allCategoriesData,
    refetch: refetchAllCategories,
    ...allCategories
  } = useQuery({
    queryKey: ['allCategories', organization.marketId, i18n.language],
    queryFn: () => getSalesCategorysNew(welletContext, organization.marketId),
    ...defaultQueryOptions,
  });

  // Fetch all available categories by user
  const {
    data: allCategoriesByUserData,
    refetch: refetchUserCategories,
    ...allCategoriesByUser
  } = useQuery({
    queryKey: ['usersLoyalty', organization.marketId, i18n.language],
    queryFn: () => getUserSalesCategorys(welletContext, organization.marketId, id),
    ...defaultQueryOptions,
    onSuccess: (data) => {
      const userCategoryId = data?.data?.categoryId;
      setSelectedCategoryId(userCategoryId);
    },
  });

  // Mutations
  const changesCategoryQuery = useMutation({
    mutationFn: (body) => {
      const response = changesCategory(welletContext, organization.marketId, body);
      return response;
    },
    onSuccess: () => {
      // callback();
      refetchAllCategories();
      refetchUserCategories();
    },
  });

  const onSubmit = () => {
    if (selectedCategoryId && selectedCategoryId !== allCategoriesByUserData?.data?.categoryId) {
      const body = {
        userId: id,
        saleCategoryId: selectedCategoryId,
      };
      changesCategoryQuery.mutate(body);
    }
  };

  // Map categories to HTML
  const timelineRows = allCategoriesData?.data
    ?.filter((c) => c.schemeType !== 'FIXED' && c.affiliateType === affiliateType)
    ?.map((category) => (
      <div key={category.id} className={styles.timelineRow}>
        <div className={styles.pointInfo}>
          <div className={styles.pointsValue}>{affiliateType === 'INTERNAL_STAFF' ? '$' : '' }{category.targetPoints}</div>
        </div>
        <input
          type='radio'
          name='category'
          id={`category${category.id}`}
          className={styles.radioInput}
          checked={category.id === selectedCategoryId}
          onChange={() => setSelectedCategoryId(category.id)}
        />
        <label
          htmlFor={`category${category.id}`}
          className={`${styles.card} ${
            category.id === selectedCategoryId ? styles.cardSelected : ''
          }`}
        >
          <div className={styles.cardContent}>
            <div>
              {category.name}
              <div className='tw-text-sm tw-text-muted-foreground tw-font-normal'>
                <div className='tw-flex tw-gap-2'>
                  <div>Concierge: {category.defaultCommissionPercentage}%</div>
                  <div>RP: {category.defaultCommissionPercentageLevel2}%</div>
                </div>
              </div>
            </div>
            {category.id === allCategoriesByUserData?.data?.categoryId && (
              <div className={styles.currentBadge}>{t('currentClass')}</div>
            )}
          </div>
        </label>
      </div>
    ));

  const isIndependent =
    affiliateType === 'INDEPENDENT' ||
    allCategoriesData?.data?.find((c) => c.id === allCategoriesByUserData?.data?.categoryId)
      ?.schemeType === 'FIXED';

  return (
    <>
      <Show>
        <Show.When isTrue={allCategories.isLoading || allCategoriesByUser.isLoading}>
          <Loading global={true} />
        </Show.When>

        <Show.Else>
          {isIndependent ? (
            <>
              <div className='mt-3'></div>
              <FormHeader
                title={affiliateType === 'CONCIERGE' ? t('titleConcierge') : t('titleIndependent')}
                subtitle={affiliateType === 'CONCIERGE' ? t('textConcierge') : t('textIndependent')}
                border={true}
              />
              <ContanierSection maxWidth='900px'>
                <div className=' tw-mt-6 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6'>
                  <div className='tw-flex tw-flex-col tw-col-span-1 '>
                    <Card className='tw-border-1'>
                      <CardContent className='!tw-p-4'>
                        <div className='tw-flex tw-items-center tw-gap-3'>
                          <div className='tw-flex-1'>
                            <p className='tw-text-sm tw-font-medium tw-text-muted-foreground'>
                              {t('commission')}
                            </p>
                            <div className='tw-mt-0.5 tw-flex tw-items-baseline tw-gap-1'>
                              <span className='tw-text-3xl tw-font-bold tw-tracking-tight'>
                                {
                                  allCategoriesData?.data?.find(
                                    (c) => c?.affiliateType === 'INDEPENDENT',
                                  )?.defaultCommissionPercentage
                                }
                              </span>
                              <span className='tw-text-xl tw-font-semibold '>%</span>
                            </div>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                  <div className='tw-flex tw-flex-col tw-col-span-1 '>
                    <LoyaltyCommissionCard id={id} className={''} userQuery={userQuery} />
                  </div>
                </div>
              </ContanierSection>
            </>
          ) : (
            <>
              {' '}
              <div className='mt-3'></div>
              <div className='tw-mt-6 tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-6'>
                <div className='tw-flex tw-flex-col tw-col-span-3 md:tw-col-span-2'>
                  {' '}
                  <CardForm
                    title={t('subHeader')}
                    subtitle={t('subHeadDesc', {
                      name:
                        affiliateType === 'CONCIERGE'
                          ? tGeneric('concierge')
                          : tGeneric('internal_staff'),
                    })}
                    endComponent={
                      hasAllowedRoles(roles, [
                        'superadministrator',
                        'marketadmin',
                        'affiliatecenter',
                      ]) ? (
                        <div className='tw-flex tw-items-center tw-justify-end tw-gap-1.5'>
                          <Button
                            type='button'
                            variant={'outline'}
                            disabled={
                              changesCategoryQuery.isLoading || changesCategoryQuery.isFetching
                            }
                            onClick={() =>
                              setSelectedCategoryId(allCategoriesByUserData?.data?.categoryId)
                            }
                          >
                            {t('cancel')}
                          </Button>
                          <Button
                            disabled={
                              changesCategoryQuery.isLoading || changesCategoryQuery.isFetching
                            }
                            type='button'
                            onClick={onSubmit}
                          >
                            {t('save')}
                          </Button>
                        </div>
                      ) : null
                    }
                  >
                    <div className='tw-mt-3'>
                      <div className={styles.wrapper}>
                        <div className={styles.containerHeader}>
                          <div className={styles.content}>
                            <div className={styles.status}>
                              {affiliateType === 'CONCIERGE' ? (
                                <p className='fs-lg fw-400'>
                                  {t('status')}
                                  {': '}
                                  <span className={styles.statusLoyalty}>
                                    {allCategoriesByUserData?.data?.category}
                                  </span>
                                </p>
                              ) : (
                                <div className={styles.points}>
                                  <p className='fs-lg fw-400'>
                                    {t('salesVolume')}
                                    {': '}
                                    <span className=' fw-600'>
                                      ${allCategoriesByUserData?.data?.points || 0}
                                    </span>
                                  </p>
                                </div>
                              )}
                            </div>
                            {affiliateType === 'CONCIERGE' ? (
                              <div className={styles.points}>
                                <p className='fs-lg fw-400'>
                                  {t('points')}
                                  {': '}
                                  <span className=' fw-600'>
                                    {allCategoriesByUserData?.data?.points || 0}
                                  </span>
                                </p>
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className={styles.timeline}>{timelineRows}</div>
                      </div>
                    </div>
                  </CardForm>
                </div>
                <div className='tw-flex tw-flex-col tw-col-span-3  md:tw-col-span-1 '>
                  <LoyaltyCommissionCard id={id} className={''} userQuery={userQuery} />
                </div>
              </div>
            </>
          )}
        </Show.Else>
      </Show>

      <Show.When isTrue={changesCategoryQuery.isSuccess}>
        <Toast message={t('toast.success')} type={`SUCCESS`} onCallback={() => null} />
      </Show.When>
      <Show.When isTrue={changesCategoryQuery.isError}>
        <Toast message={t('toast.errors')} type={`ERROR`} onCallback={() => null} />
      </Show.When>
    </>
  );
};

export default Loyalty;
